<template>
  <a-popover v-model="visible" placement="bottomLeft" @confirm="confirm">
    <template #title>
      <div style="width: 380px">
        <div class="titleLine1">
          <div class="titleLine1Left">
            <img :src="userInfo.company.logo" style="width: 54px; height: 54px" />
            <div>
              <span class="companyName">{{ userInfo.company.companyName }}</span>
              <img :src="levelPhoto" class="levelPhoto" style="width: 52px" />
            </div>
          </div>
          <a @click="$router.push('/' + userInfo.primaryMemberCode)">访问云展 <a-icon type="right" /></a>
        </div>
        <div class="titleLine2">
          <span style="color: #ed7b30">{{ updateBoxInfo.content }}</span>
          <img
            :src="updateBoxInfo.btnSrc"
            :alt="updateBoxInfo.content"
            style="cursor: pointer; width: 78px"
            @click="toUpgrade"
          />
        </div>
      </div>
    </template>
    <template #content>
      <div class="content">
        <span @click.stop="$router.push(`${$store.getters.getConsolePath}/basicInfo`)"
          ><a-icon type="setting" /> 个人账号设置</span
        >
        <span @click.stop="logout"><a-icon type="logout" /> 退出当前账号</span>
      </div>
    </template>

    <a-space>
      <slot></slot>
    </a-space>
  </a-popover>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  VIP_LEVEL_0,
  VIP_LEVEL_1,
  VIP_LEVEL_2,
  VIP_LEVEL_3,
  VIP_LEVEL_4,
  VIP_LEVEL_5,
  VIP_LEVEL_6,
  VIP_LEVEL_7,
  VIP_LEVEL_8,
} from '@/const/image';

import { logoutMixin } from '~/mixin/logout-mixin';

export default {
  mixins: [logoutMixin],
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),
    // 等级按钮
    levelPhoto() {
      let level = false;
      if (this.userInfo?.memberSetMealInfo?.setMealCode) {
        const setMealCode = this.userInfo.memberSetMealInfo.setMealCode;
        switch (setMealCode) {
          case 110000:
            level = VIP_LEVEL_0;
            break;
          case 10000:
            level = VIP_LEVEL_1;
            break;
          case 20000:
            level = VIP_LEVEL_2;
            break;
          case 30000:
            level = VIP_LEVEL_3;
            break;
          case 40000:
            level = VIP_LEVEL_4;
            break;
          case 50000:
            level = VIP_LEVEL_5;
            break;
          case 60000:
            level = VIP_LEVEL_6;
            break;
          case 70000:
            level = VIP_LEVEL_7;
            break;
          case 80000:
            level = VIP_LEVEL_8;
            break;
        }
      }

      return level;
    },
    // 升级还是续费模块
    updateBoxInfo() {
      const src = 'https://oss-resource668.yzdli.com/website/image/default/upgradeVip/';
      if (this.userInfo?.memberSetMealInfo) {
        const isBase = this.userInfo.memberSetMealInfo.isBase;
        if (isBase === 1) {
          return {
            content: '升级企业套餐,享更多专属权益',
            btnSrc: this.$i18n.locale === 'zh' ? `${src}btn_upgrade.png` : `${src}btn_upgrade_en.png`,
          };
        } else {
          return {
            content: `${this.$t('到期时间')}:${this.userInfo.memberSetMealInfo.expiredTme}`,
            btnSrc: this.$i18n.locale === 'zh' ? `${src}btn_xufei.png` : `${src}btn_xufei_en.png`,
          };
        }
      } else {
        return {
          content: '',
          btnSrc: '',
          expiredTme: null,
        };
      }
    },
  },

  methods: {
    confirm() {
      this.$message({
        type: 'success',
        message: 'Clicked on Yes',
      });
    },
    // 前往升级或者续费
    toUpgrade() {
      this.$router.push('/upgradevip');
    },
  },
};
</script>
<style lang="scss" scoped>
.titleLine1 {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 14px;
  .titleLine1Left {
    display: flex;
    > div {
      display: flex;
      flex-direction: column;
      margin-left: 11px;
      .companyName {
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        margin-bottom: 7px;
      }
    }
  }

  a {
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
}
.titleLine2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 21px;
}
.content {
  display: flex;
  flex-direction: column;
  span {
    font-size: 14px;
    color: #333;
    cursor: pointer;
    &:nth-of-type(1) {
      margin-bottom: 16px;
    }
    i {
      margin-right: 10px;
    }
  }
}
</style>
